<template>
  <div class="summary-col">
    <div class="summary-card">
      <div
        class="sc-img"
        :style="week ? `background-image: url('${getImg(0)}')` : ''"
      >
      </div>
      <div class="sc-body">
        <div class="sc-resort">{{ getText("ResortName") }}</div>
        <div class="sc-addr">{{
          `${getText("ResortAddress1")} ${getText("ResortAddress2")} ${getText("ResortAddress3")}`
        }}</div>
        <template v-if="selectedUnit">
          <div class="sc-row">
            <span class="sc-label">{{ $func.parseIso("checkInLabel") }}</span>
            <span class="sc-val">{{ formatDate(summaryCheckIn) }}</span>
          </div>
          <div class="sc-row">
            <span class="sc-label">{{ $func.parseIso("checkOutLabel") }}</span>
            <span class="sc-val">{{ formatDate(summaryCheckOut) }}</span>
          </div>
          <div class="sc-row">
            <span class="sc-label">{{ $func.parseIso("duration") }}</span>
            <span class="sc-val">{{ summaryNights }} {{ $func.parseIso("nights") }}</span>
          </div>
          <div class="sc-row">
            <span class="sc-label">{{ $func.parseIso("unit") }}</span>
            <span class="sc-val">{{ summaryUnitType }}</span>
          </div>
          <div class="sc-row">
            <span class="sc-label">{{ $func.parseIso("weekType") }}</span>
            <span class="sc-val">
              <span class="sc-wt" :class="wtPillClass(summaryWeekType)">{{ summaryWeekType }}</span>
            </span>
          </div>
          <div class="sc-row">
            <span class="sc-label">{{ $func.parseIso("kitchen") }}</span>
            <span class="sc-val">{{ summaryKitchen }}</span>
          </div>
          <div class="sc-row">
            <span class="sc-label">{{ $func.parseIso("maxGuests") }}</span>
            <span class="sc-val">{{ summaryMaxOccupancy }} {{ $func.parseIso("guests") }}</span>
          </div>
          <template v-if="traveler">
            <div class="sc-traveler-title">
              <i class="fa-regular fa-user"></i>
              {{ $func.parseIso("primaryContact") }}
            </div>
            <div class="sc-row" v-if="travelerName">
              <span class="sc-label">{{ $func.parseIso("name") }}</span>
              <span class="sc-val">{{ travelerName }}</span>
            </div>
            <div class="sc-row" v-if="traveler.email">
              <span class="sc-label">{{ $func.parseIso("email") }}</span>
              <span class="sc-val">{{ traveler.email }}</span>
            </div>
            <div class="sc-row" v-if="traveler.phone">
              <span class="sc-label">{{ $func.parseIso("cellphone") }}</span>
              <span class="sc-val">{{ traveler.phone }}</span>
            </div>
            <div class="sc-row" v-if="travelerAddress">
              <span class="sc-label">{{ $func.parseIso("address") }}</span>
              <span class="sc-val">{{ travelerAddress }}</span>
            </div>
          </template>
          <div class="sc-divider"></div>
          <div v-if="descuentoLoading" class="sc-loading">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <span>{{ $func.parseIso("calculating") || "Calculando..." }}</span>
          </div>
          <template v-else-if="descuentoData">
            <div class="sc-row">
              <span class="sc-label">{{ $func.parseIso("total") }}</span>
              <span class="sc-val">${{ descuentoData.precioBase }}</span>
            </div>
            <div class="sc-row" v-if="descuentoData.descuentoCupon > 0">
              <span class="sc-label">
                {{ $func.parseIso("couponDiscount") || 'Cupón' }}
                <span v-if="descuentoData.cuponAplicado && descuentoData.cuponAplicado.codigo" class="sc-cupon-code">({{ descuentoData.cuponAplicado.codigo }})</span>
              </span>
              <span class="sc-val sc-val--discount">-${{ descuentoData.descuentoCupon }}</span>
            </div>
            <div class="sc-row" v-if="descuentoData.descuentoPuntos > 0">
              <span class="sc-label">
                {{ $func.parseIso("pointsDiscount") || 'Puntos' }}
                <span class="sc-cupon-code">({{ descuentoData.puntosUsados }} pts)</span>
              </span>
              <span class="sc-val sc-val--discount">-${{ descuentoData.descuentoPuntos }}</span>
            </div>
            <div class="sc-row sc-row--final">
              <span class="sc-label">{{ $func.parseIso("totalToPay") || 'Total a pagar' }}</span>
              <span class="sc-val sc-val--final">${{ descuentoData.precioFinal }}</span>
            </div>
          </template>
          <div class="sc-total-row" v-else>
            <div>
              <div class="sc-total-lbl">{{ $func.parseIso("total") }}</div>
              <div class="sc-total">${{ summaryCost }}</div>
              <div class="sc-ppn">${{ summaryPerNight }} {{ $func.parseIso("perNight") }} &middot; {{ summaryNights }} {{ $func.parseIso("nights") }}</div>
            </div>
            <button
              class="sc-book-btn"
              :class="{ 'sc-book-btn--loading': bookingLoading }"
              :disabled="bookingLoading"
              @click="$emit('book')"
              v-if="step === 2"
            >
              <i v-if="bookingLoading" class="fa-solid fa-spinner fa-spin"></i>
              <template v-else>{{ msgBtn ? msgBtn : $func.parseIso("book") }}</template>
            </button>
          </div>
          <div
            class="sc-timer"
            :class="{ 'sc-timer--warn': remaining <= 60 }"
            v-if="(step === 3 || step === 4) && remaining > 0 && !timerDisabled"
          >
            <i class="fa-regular fa-clock"></i>
            <span>{{ timerFormatted }}</span>
          </div>
          <div class="sc-nr">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            <span><strong>{{ $func.parseIso("nonRefundableShort") }}</strong> {{ $func.parseIso("nonRefundableFull") }}</span>
          </div>
        </template>
        <div class="sc-empty" v-else>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="7" width="18" height="13" rx="2"></rect>
            <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"></path>
          </svg>
          <span>{{ $func.parseIso("selectReservation") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SummaryCard",
  props: {
    week: { type: Object, default: () => ({}) },
    selectedUnit: { type: Object, default: null },
    step: { type: Number, default: 2 },
    remaining: { type: Number, default: 0 },
    timerFormatted: { type: String, default: "" },
    timerDisabled: { type: Boolean, default: false },
    msgBtn: { type: String, default: null },
    traveler: { type: Object, default: null },
    bookingLoading: { type: Boolean, default: false },
    descuentoData: { type: Object, default: null },
    descuentoLoading: { type: Boolean, default: false },
  },
  computed: {
    summaryUnitType() {
      return this.selectedUnit ? this.selectedUnit.UnitType : "";
    },
    summaryWeekType() {
      return this.selectedUnit ? this.selectedUnit.InvTypeInDetail : "";
    },
    summaryKitchen() {
      return this.selectedUnit ? this.selectedUnit.KitchenType : "";
    },
    summaryMaxOccupancy() {
      return this.selectedUnit ? this.selectedUnit.MaxOccupancy : "";
    },
    summaryCheckIn() {
      return this.selectedUnit ? this.selectedUnit.CheckInDate : "";
    },
    summaryCheckOut() {
      return this.selectedUnit ? this.selectedUnit.CheckOutDate : "";
    },
    summaryNights() {
      return this.selectedUnit ? this.selectedUnit.Nights : "";
    },
    summaryCost() {
      return this.selectedUnit ? this.selectedUnit.Cost : 0;
    },
    summaryPerNight() {
      if (!this.selectedUnit) return 0;
      const nights = parseFloat(this.selectedUnit.Nights) || 1;
      const cost = parseFloat(this.selectedUnit.Cost) || 0;
      return Math.round((cost / nights) * 100) / 100;
    },
    travelerName() {
      if (!this.traveler) return "";
      return [this.traveler.name, this.traveler.lastname]
        .filter(Boolean)
        .join(" ");
    },
    travelerAddress() {
      if (!this.traveler) return "";
      return [
        this.traveler.address,
        this.traveler.city,
        this.traveler.state,
        this.traveler.zipcode,
        this.traveler.country,
      ]
        .filter(Boolean)
        .join(", ");
    },
  },
  methods: {
    getText(key, firstText = "") {
      if (this.week)
        return this.week[key] ? `${firstText} ${this.week[key]}` : "";
      else return "";
    },
    formatDate(date) {
      return this.$moment(date).format("ll");
    },
    getImg(position) {
      if (this.week)
        return (
          this.week.imgs[position] ||
          "https://dicesabajio.com.mx/wp-content/uploads/2021/06/no-image.jpeg"
        );
      else
        return "https://dicesabajio.com.mx/wp-content/uploads/2021/06/no-image.jpeg";
    },
    wtPillClass(name) {
      const n = (name || "").toLowerCase();
      if (n.includes("smart")) return "wtp-smart";
      if (n.includes("vip")) return "wtp-vip";
      return "wtp-default";
    },
  },
};
</script>

<style scoped>
.summary-card {
  background: #fff;
  border: 1px solid #e0e6ea;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}

.sc-img {
  position: relative;
  aspect-ratio: 1.25 / 1;
  background-color: #cfd8dc;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-end;
}

.sc-body {
  padding: 14px;
}

.sc-resort {
  font-size: 16px;
  font-weight: 700;
  color: #102a43;
  margin-bottom: 2px;
}

.sc-addr {
  font-size: 12px;
  color: #627d98;
  margin-bottom: 12px;
}

.sc-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  padding: 6px 0;
  border-top: 1px dashed #e4e7eb;
}

.sc-label {
  color: #627d98;
}

.sc-val {
  color: #243b53;
  font-weight: 600;
  text-align: right;
}

.sc-wt {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.sc-wt.wtp-vip {
  background: #fff5d6;
  color: #8a6d1b;
}

.sc-wt.wtp-smart {
  background: #e3f2fd;
  color: #1565c0;
}

.sc-wt.wtp-default {
  background: #eceff1;
  color: #455a64;
}

.sc-divider {
  height: 1px;
  background: #e0e6ea;
  margin: 12px 0;
}

.sc-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 0;
  color: #627d98;
  font-size: 13px;
  font-weight: 600;
}

.sc-loading i {
  font-size: 16px;
  color: #0472aa;
}

.sc-traveler-title {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #e4e7eb;
  font-size: 13px;
  font-weight: 700;
  color: #102a43;
  display: flex;
  align-items: center;
  gap: 6px;
}

.sc-traveler-title i {
  color: #0472aa;
  font-size: 14px;
}

.sc-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.sc-total-lbl {
  font-size: 12px;
  color: #627d98;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.sc-total {
  font-size: 24px;
  font-weight: 800;
  color: #102a43;
}

.sc-ppn {
  font-size: 12px;
  color: #627d98;
}

.sc-book-btn {
  background: #0472aa;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-weight: 700;
  cursor: pointer;
}

.sc-book-btn:hover {
  background: #00527c;
}

.sc-book-btn:disabled,
.sc-book-btn--loading {
  opacity: 0.6;
  cursor: not-allowed;
}

.sc-timer {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #e3f2fd;
  color: #0472aa;
  border: 1px solid #bbdefb;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 700;
  font-size: 15px;
  white-space: nowrap;
}

.sc-timer i {
  font-size: 16px;
}

.sc-timer.sc-timer--warn {
  background: #fff4f2;
  color: #c63727;
  border-color: #f3c9bf;
}

.sc-nr {
  margin-top: 12px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  background: #fff4f2;
  border: 1px solid #f3c9bf;
  color: #9a3412;
  padding: 10px;
  border-radius: 8px;
  font-size: 12px;
}

.sc-nr svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}

.sc-empty {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  background: #f5f7fa;
  border: 1px dashed #cfd8dc;
  color: #627d98;
  padding: 20px 14px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
}

.sc-empty svg {
  width: 28px;
  height: 28px;
  color: #0472aa;
  flex-shrink: 0;
}

.sc-cupon-code {
  font-size: 11px;
  color: #9aa5b1;
  font-weight: 500;
}

.sc-val--discount {
  color: #16a34a;
}

.sc-row--final {
  border-top: 1px solid #e0e6ea;
  margin-top: 4px;
  padding-top: 10px;
}

.sc-val--final {
  font-size: 18px;
  font-weight: 800;
  color: #102a43;
}
</style>
